<template>
    <div>
     <b-form-checkbox @click.native="clickedCheckbox" v-model="checked" name="check-button" switch class="ml-3 mb-4" >
      Toon enkel de werken die te koop zijn
    </b-form-checkbox>
        <div class="row">
            <div  v-for="(image, index) in getImagesToShow()" :key="image.url" class="col-md-4 col-sm-6 col-xs-12 mb-2">
                <div class="gallery-image-container d-flex align-items-center">
                    <galleryItem :image-info="image" @clicked="clickedGalleryItem(index)"></galleryItem>
                </div>
            </div>
        </div>
        <b-modal id="image-modal"  size="lg" :centered="true" :hide-footer="true" :title="'Werk #' + imagesToShow[selectedIndex].title" header-class="image-modal-header" body-class="image-modal-body">
            <div class="image-modal-description">{{imagesToShow[selectedIndex].size}} cm  -  {{imagesToShow[selectedIndex].material}}  -  {{imagesToShow[selectedIndex].sale}}</div>
            <img class="image-modal-image" :src="getImgUrl(imagesToShow[selectedIndex].largeUrl)">
        </b-modal>
    </div>
</template>

<script>
import GalleryItem from './GalleryItem.vue';
import {paintings} from '../data/paintings.ts';
export default {
  name: 'GalleryView',
  components: {
      GalleryItem
  },
data: () => {
    return {
    images: paintings,
    imagesToShow: paintings,
    selectedIndex: 1,
    checked: false
    };
},
methods: {
    getImgUrl(picName) {
        return require('../assets/gallery/'+ picName);
    },
     showModal() {
        this.$bvModal.show('image-modal');
      },
      closeModal() {
        this.$bvModal.closeModal();
        this.selectedIndex = null;
      },
    clickedGalleryItem(index) {
        this.selectedIndex = index;
        this.showModal();
    },
    clickedCheckbox(evt) {
        if (evt.target.tagName === 'INPUT') {
            if(evt.target.checked) {
             this.imagesToShow = this.images.filter((i) => i.sale !== "Niet te koop" && i.sale !== "Verkocht" );
            } else {
                this.imagesToShow = this.images;
            }
        }
    },
    getImagesToShow() {
       return this.imagesToShow;
    }}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.gallery-image-container{
    height: 100%;
    width:100%;
    margin: 5px 0;
}
.image-modal-image{
    width:100%;
}
.image-modal-description{
    color: gray;
    padding-bottom: 1rem;
    font-style: italic;
}


</style>